<template>
  <div class="auth-form">
    <form :id="$options.csrfFormId" class="auth-form__form">
      <div v-html="antiForgeryHtml"></div>
      <h1 class="auth-form__title">{{ $res.Views.AuthForm_Title }}</h1>
      <authorization-component :server-errors="serverErrors"
                               :registration-url="viewModel.CmsLoginRegisterUrl"
                               :forgot-password-url="viewModel.CmsLoginForgotPasswordUrl"
                               :cooperation-url="viewModel.CmsLoginCooperationUrl"
                               @authorize="authorize" 
                               @validation-failed="serverErrors = []" />
    </form>
  </div>
</template>

<script>
import AuthorizationComponent from "@/authorization/components/AuthorizationComponentDesktop.vue";
import ValidationWrapper from "@/common/ComponentValidationWrapper.vue";
import Base from "./AuthorizationAppBase";

export default {
  components: {
    ValidationWrapper,
    AuthorizationComponent,
  },
  mixins: [Base],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.auth-form {
  background-color: var(--white);
  width: 360px;
  margin: 20px auto;
  box-shadow: var(--shadow);
  border-radius: var(--border-radius-lg);
  overflow: hidden;
}

.auth-form__form {
  padding-top: 20px;
}

.auth-form__tabs {
  display: flex;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
}

.auth-form__tabs > div {
  text-align: center;
  background-color: var(--main-40);
  display: block;
  width: 50%;
  padding: 5px 0;
  color: var(--white);
}

.auth-form__tabs > div.active {
  background-color: var(--white);
  color: var(--second-10);
}

.auth-form__title {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 38px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
